export function secondsToDays(seconds) {
  return seconds / 60 / 60 / 24;
}
